import { format } from "date-fns";

export const UI_ACTION_PORTAL_ID = "ui-action-portal";
export const SECONDARY_SIDEBAR = "SECONDARY_SIDEBAR";
export const HEADER_CONTENT_PORTAL_ID = "header-content-portal";
// Page-level banner slot rendered directly below the app header.
export const PAGE_BANNER_PORTAL_ID = "page-banner-portal";
export const LAYOUT_TABS_ID = "layout-tabs";

export function cn(...inputs) {
  return inputs.filter(Boolean).join(" ");
}

export function formatName(person) {
  if (!person) return "";
  const { first_name, last_name } = person;
  return `${first_name} ${last_name}`;
}

export function monthYearKey(date) {
  return date ? format(date, "yyyy-MM") : "";
}

export const applySorting = (sortBy, sortOrder) => {
  if (sortOrder && sortBy) {
    return [`${sortOrder === "desc" ? "-" : ""}${sortBy}`, "-id"];
  }
  return "";
  // return ["-date_created"]; // Default sorting
};

export function assetUrl(id) {
  if (!id) {
    return null;
  }
  const baseUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_BASE_URL) || process.env.NEXT_PUBLIC_BASE_URL || '';
  return `${baseUrl}/assets/${id}`;
}

export function fileUrl(id) {
  if (!id) {
    return null;
  }
  const baseUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_BASE_URL) || process.env.NEXT_PUBLIC_BASE_URL || '';
  return `${baseUrl}/files/${id}`;
}

export { getColorClasses } from "./color-classes.js";